<script>
import { mapGetters } from 'vuex'
import OrdersWrapper from '@/components/orders/OrdersWrapper.vue'
import ordersJson from '@/data/json/orders/view.json'
export default {
  name: 'OrdersComponent',
  components: { OrdersWrapper },
  props: {
    // property from route, need to be string
    viewName: { type: String }
  },
  data: () => ({
    content: ordersJson.data
  }),
  computed: {
    ...mapGetters(['locale'])
  },
  created() {
    this.$cmsService
      .fetchContent('orderscontents')
      .then(response => {
        this.content = response
      })
      .catch(() => {})
  },
  methods: {
    changeView(view) {
      this.view = view
    }
  }
}
</script>
<template>
  <v-container fluid>
    <OrdersWrapper :view-name="viewName" />
  </v-container>
</template>
